// extracted by mini-css-extract-plugin
module.exports = {"serverUri":"style_serverUri__2wAjQ","filterBoxStandardWidth":"style_filterBoxStandardWidth__PZ1HV"};